import React, {useEffect, useState} from 'react';
import localStrings from "../../localStrings";
import CardContent from "@mui/material/CardContent";
import {CardHeader} from "@mui/material";
import Card from "@mui/material/Card";
import {executeQueryUtil} from "../../utils/gqlUtil";
import {getAllEstablishmentsQuery} from "../../gql/establishmentGql";
import useAuth from "../../hooks/useAuth";
import PageWithTitle from "../../components/pages/pageWithTitle";
import SynchoEstablishmentItem from "./SynchoEstablishmentItem";
import {useCollectionData} from "react-firebase-hooks/firestore";
import {collection, getFirestore} from "firebase/firestore";
import {BRAND_COLLECTION, ESTABLISHMENT_COLLECTION} from "../../utils/constants";

function  Synchronisation() {


    const db = getFirestore();
    const { currentBrand } = useAuth();

    const refCollection =  collection(db, BRAND_COLLECTION
        + "/" + currentBrand().id + "/" + ESTABLISHMENT_COLLECTION );

    const [establishmentsDb, establishmentsDbLoading, establishmentsDbError] = useCollectionData(
        refCollection
        , {
            snapshotListenOptions: { includeMetadataChanges: true },
        });

    const [itemSource, setItemSource] = useState([]);


    useEffect(() => {
        async function setItemSourceAsync() {
            let result =  await executeQueryUtil(getAllEstablishmentsQuery(currentBrand().id));
            setItemSource(result?.data?.getEstablishments || []);
        }
        setItemSourceAsync();
    }, [currentBrand]);


    return (
        <PageWithTitle title={localStrings.synchronisation}>
            <Card>
                <CardContent>
                    {(itemSource || []).map((item, index) =>
                       <SynchoEstablishmentItem
                           establishmentDb={(establishmentsDb || []).find(establishmentDb => establishmentDb.id === item.id)}
                           establishment={item} key={index}/>
                    )}
                </CardContent>
            </Card>
        </PageWithTitle>

    )
}

export default  Synchronisation